// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2PKMo","title":"Images45_title__2Bggc","images":"Images45_images__2UPwj"};